import styled from "styled-components";
import { FC } from "react";

import Text from "@/components/Text";

const Badge = styled.div`
  background: ${({ theme }) => theme.colors.lightGray};
  padding: 9px 16px;
  border-radius: 4px;
`;

const StyledText = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    flex-shrink: 0;
    margin-left: 6px;
  }
`;

interface Props {
  hasConditions: boolean;
}

const ConditionalRepostBadge: FC<Props> = ({ hasConditions }) => {
  return (
    <Badge>
      <StyledText $type="smallHeadline" $color="purple">
        {hasConditions ? "Conditional repost" : "Repost"}
        <svg
          width="12"
          height="13"
          viewBox="0 0 12 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="6" cy="6.5" r="5.5" stroke="#5D54D6" />
          <path
            d="M5.5 4.80147V3.875H6.5V4.80147H5.5ZM5.5 9.125V5.41912H6.5V9.125H5.5Z"
            fill="currentColor"
          />
        </svg>
      </StyledText>
    </Badge>
  );
};

export default ConditionalRepostBadge;
